/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CombineLeads200ResponseData
 */
export interface CombineLeads200ResponseData {
    /**
     * Combined lead ID
     */
    combined_lead_id: string;
}

/**
 * Check if a given object implements the CombineLeads200ResponseData interface.
 */
export function instanceOfCombineLeads200ResponseData(value: object): value is CombineLeads200ResponseData {
    if (!('combined_lead_id' in value) || value['combined_lead_id'] === undefined) return false;
    return true;
}

export function CombineLeads200ResponseDataFromJSON(json: any): CombineLeads200ResponseData {
    return CombineLeads200ResponseDataFromJSONTyped(json, false);
}

export function CombineLeads200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CombineLeads200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'combined_lead_id': json['combined_lead_id'],
    };
}

export function CombineLeads200ResponseDataToJSON(json: any): CombineLeads200ResponseData {
    return CombineLeads200ResponseDataToJSONTyped(json, false);
}

export function CombineLeads200ResponseDataToJSONTyped(value?: CombineLeads200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'combined_lead_id': value['combined_lead_id'],
    };
}

